import React from 'react'
import { StyledVideoIcon } from '../../icons/IconVideo2/IconVideo2.styled'

export interface IconVideo2Props {
    className?: string
    width: number
    height: number
    horizontalSpacing?: number
    fill?: string
}

export const IconVideo2: React.FC<IconVideo2Props> = ({
    width,
    height,
    horizontalSpacing,
    className,
    fill,
}) => (
    <StyledVideoIcon
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
        width={width}
        height={height}
        horizontalSpacing={horizontalSpacing}
        fill="none"
        className={className}
    >
        <title>Video</title>
        <path
            d="M12.5684 4.69857C12.5684 4.60658 12.4712 4.54635 12.3889 4.58748L9.59815 5.98258V8.01685L12.3889 9.41252C12.4712 9.45365 12.5684 9.39341 12.5684 9.30143V4.69857ZM8.48503 4.27759C8.48492 3.83354 8.12471 3.47333 7.68066 3.47323H2.23584C1.79179 3.47333 1.43158 3.83354 1.43148 4.27759V9.72241C1.43158 10.1665 1.79179 10.5267 2.23584 10.5268H7.68066C8.12471 10.5267 8.48492 10.1665 8.48503 9.72241V4.27759ZM9.59815 4.73787L11.891 3.59172C12.7138 3.18035 13.6815 3.77873 13.6815 4.69857V9.30143C13.6815 10.2213 12.7138 10.8196 11.891 10.4083L9.59815 9.26156V9.72241C9.59804 10.7815 8.73976 11.6398 7.68066 11.6399H2.23584C1.17675 11.6398 0.318463 10.7815 0.318359 9.72241V4.27759C0.318462 3.2185 1.17675 2.36021 2.23584 2.36011H7.68066C8.73976 2.36021 9.59804 3.2185 9.59815 4.27759V4.73787Z"
            fill={fill ?? '#535556'}
        />
    </StyledVideoIcon>
)
